import { createTheme } from "@mui/material";

const lightTokens = {
  primary:    { main: "#1B2559", dark: "#131c47" },
  background: { default: "#F8F9FC", paper: "#FFFFFF" },
  text:       { primary: "#1B2559", secondary: "#5A6A8A" },
  divider:    "#E2E8F0",
  chatBorder: "#d9e5ef",
  systemNotificationBorder: "#bbc9db",
  action:     { active: "#1B2559" },
  // legacy custom tokens
  fontColor:     { main: "#1d77f7" },
  paragraphFont: { main: "#3e3e3e" },
};

const darkTokens = {
  primary:    { main: "#7B93D1", dark: "#5a74b8" },
  background: { default: "#0F1117", paper: "#1A1D2E" },
  text:       { primary: "#E2E8F0", secondary: "#8A9ABB" },
  divider:    "#2D3250",
   chatBorder: "#d9e5ef",
  systemNotificationBorder: "#bbc9db",
  action:     { active: "#E2E8F0" },
  // legacy custom tokens
  fontColor:     { main: "#7BADFF" },
  paragraphFont: { main: "#C0C8D8" },
};

export const getTheme = (mode = "light") => {
  const tokens = mode === "dark" ? darkTokens : lightTokens;
  return createTheme({
    palette: {
      mode,
      primary:    tokens.primary,
      background: tokens.background,
      text:       tokens.text,
      divider:    tokens.divider,
      action:     tokens.action,
      // legacy custom palette tokens (kept for backward compat)
      fontColor:     tokens.fontColor,
      paragraphFont: tokens.paragraphFont,
      clickHereButton: { main: "#d82244" },
      footerBg:        { main: "#d82244" },
      blueFooter:      { main: "#164B60" },
    },
    typography: {
      fontFamily: ["'Open Sans'", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(","),
      blueFont: {
        fontSize: "18px",
        fontFamily: ["'Open Sans'", "sans-serif"].join(","),
      },
      paraFont: {
        fontFamily: ["'Open Sans'", "sans-serif"].join(","),
        fontSize: "14px",
        fontWeight: "500",
        textAlign: "justify",
      },
    },
  });
};

// Default export — light theme (legacy fallback for any direct imports)
export default getTheme("light");
